// src/pages/locations/countries/CreateCountryPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

import { useCreateCountryMutation } from "@/api/features/locations";
import CountryForm from "@/components/locations/forms/CountryForm";

import LocationFormPage from "../components/LocationFormPage";
import { useLeaveConfirm } from "../components/form/useLeaveConfirm";
import { locationTabPath } from "../locations.access";
import { withFlash } from "../flash";

const CreateCountryPage: React.FC = () => {
  const navigate = useNavigate();
  const backTo = locationTabPath("countries");

  const createMutation = useCreateCountryMutation();
  const { requestCancel, dialog } = useLeaveConfirm(() => navigate(backTo));

  // Bumping this clears the form after "Save & add another".
  const [resetSignal, setResetSignal] = React.useState(0);

  return (
    <LocationFormPage
      entity="countries"
      title="Add country"
      backTo={backTo}
      backLabel="Back to Countries"
    >
      <CountryForm
        mode="create"
        isSubmitting={createMutation.isPending}
        error={createMutation.error}
        resetSignal={resetSignal}
        onCancel={requestCancel}
        onSubmit={(values, { addAnother }) =>
          createMutation.mutate(
            {
              iso2: values.iso2,
              name: values.name,
              ...(values.nameNorm ? { nameNorm: values.nameNorm } : {}),
            },
            {
              onSuccess: (created) => {
                if (addAnother) {
                  setResetSignal((n) => n + 1);
                  return;
                }
                navigate(backTo, withFlash(`${created.name} was added.`));
              },
            }
          )
        }
      />

      {dialog}
    </LocationFormPage>
  );
};

export default CreateCountryPage;
